module.exports = __webpack_public_path__ + "static/media/vulcano_2k.538c6e85.webp";